<template>
    <div class="icon-cubes"></div>
</template>